/**
 * Layout used to render the catalog ("Browse Catalog") sections on the pervasive
 * (accessibility) home. Configurable via the `features.pervasive.catalog.layout` flag.
 */
enum PervasiveCatalogLayout {
    /** Horizontal, swipe-only carousel (default). */
    Carousel = 'carousel',
    /** Wrapping, vertically scrolling grid — no horizontal swipe; all items reachable by vertical scroll and screen-reader traversal. */
    Grid = 'grid',
}

export { PervasiveCatalogLayout };
